module.exports = __webpack_public_path__ + "static/img/cha3.7258ab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha3.png
// module id = 8fOL
// module chunks = 1